import * as React from 'react';

var AccordionContext = /*#__PURE__*/React.createContext({
  collapseAll: false,
  expandedContentId: '',
  isAccordion: true
});

export { AccordionContext };
